import { atom } from "recoil";

export const chargePointState = atom({
  key: "chargePointState", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});

